export default "__VITE_ASSET__V0gsZnih__"